import { getOpenWorkSeverity, getOpenWorkSeverityLabel } from "./openWorkSeverity";

const COUNT_STYLES = {
  clear: "bg-surface-sunken text-secondary",
  few: "bg-warning-subtle text-warning ring-1 ring-warning",
  many: "bg-danger-subtle text-danger ring-1 ring-danger",
};

export default function OpenWorkLaneTabs({ lanes, active, onChange, loading = false }) {
  return (
    <div className="flex gap-2 overflow-x-auto rounded-2xl border border-neutral-200 bg-white p-2 dark:border-neutral-800 dark:bg-neutral-900" role="group" aria-label="Open work queues">
      {lanes.map(({ id, label, count }) => {
        const severity = loading ? "clear" : getOpenWorkSeverity(count);
        return (
          <button
            key={id}
            type="button"
            aria-pressed={active === id}
            onClick={() => onChange(id)}
            className={`inline-flex shrink-0 items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium transition ${active === id ? "bg-neutral-900 text-white dark:bg-white dark:text-neutral-900" : "text-neutral-600 hover:bg-neutral-100 dark:text-neutral-300 dark:hover:bg-neutral-800"}`}
          >
            {label}
            <span
              aria-label={loading ? "Loading count" : `${count}, ${getOpenWorkSeverityLabel(count).toLocaleLowerCase()}`}
              className={`inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-xs font-bold leading-none ${COUNT_STYLES[severity]}`}
            >
              {loading ? "…" : count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
